// AdicionarAoCarrinhoBtn.js
import React, { useContext } from "react";
import { CarrinhoContext } from "../../services/context/CarrinhoContext";
import { useModal } from "../../services/context/ModalContext";

const AdicionarAoCarrinhoBtn = ({
    ebook, // Este objeto já vem com { id, titulo, preco, image, formato } ou algo semelhante
    slider,
    onAddToCartSlider,
    btnText = "Adicionar ao Carrinho",
    alt = false,
    newBtn = false,
}) => {
    
    const { adicionarItem } = useContext(CarrinhoContext);
    const { openModal } = useModal();

    // Note que aqui desestruturamos tudo do "livro"
    const { id, titulo, preco, image, formato } = ebook;

    // Montamos o item a adicionar no carrinho:
    const item = { id, titulo, preco, image, formato };

    const handleAddToCart = () => {
        adicionarItem(item);

        if (slider) {
            onAddToCartSlider(item);
        }
        // Abre modal, se necessário
        openModal(item);
    };

    return (
        <button className={`${newBtn ? "new-main-btn" : "main-btn"} ${alt ? "alt" : ""}`} onClick={handleAddToCart}>
            {btnText}
        </button>
    );
};

export default AdicionarAoCarrinhoBtn;
